<div class="row col-12 mt-3 align-items-center no-gutters layout-px p-0">
    <div class="col-6 text-left p-0">
        <div style="font-weight: 600 !important; font-size: 18px;">Hello, {{profile.firstName}} {{profile.lastName}}
        </div>
    </div>
    <div class="col-6 text-right text-normal p-0">Last logged in, {{profile.lastAccess | date:'medium'}}</div>
</div>
<form [formGroup]="profileForm">
    <div class="row col-12 no-gutters layout-px p-0">
        <div class="col text-normal">
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">First Name
                <span style="color: red;">*</span>
            </div>
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0">
                <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                    <input formControlName="firstName" name="firstName" matInput #firstName
                    placeholder="" style="color: #18181a;">
                </mat-form-field>
            </div>
        </div>
        <div class="col text-normal">
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Last Name
                <span style="color: red;">*</span>
            </div>
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto">
                <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                    <input formControlName="lastName" name="lastName" matInput #lastName
                    placeholder="" style="color: #18181a;">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row col-12 no-gutters layout-px p-0">
        <div class="col text-normal">
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Company Name
                <span style="color: red;">*</span>
            </div>
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0">
                <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                    <input formControlName="companyName" name="companyName" matInput #companyName
                    placeholder="" style="color: #18181a;">
                </mat-form-field>
            </div>
        </div>
        <div class="col text-normal">
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Company Email Address
                <span style="color: red;">*</span>
            </div>
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto">
                <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                    <input formControlName="companyEmail" name="companyEmail" matInput #companyEmail
                        placeholder="" style="color: #18181a;">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row col-12 no-gutters layout-px p-0">
        <div class="col text-normal">
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Supplier ID
                <span style="color: red;">*</span>
            </div>
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0">
                <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                    <input formControlName="supplierID" name="supplierID" matInput #supplierID
                    placeholder="" style="color: #18181a;">
                    <button class="btn button text-center" style="margin-bottom: 4px;"
                    mat-button matSuffix (click)="submitProfileForm()"
                    *ngIf="profileForm.controls.supplierID.value">
                        <span style="color:#fff;">                        
                            Save
                        </span>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="col text-normal">
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">GE SSO ID
                <span style="color: red;">*</span>
            </div>
            <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto">
                <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                    <input formControlName="userName" name="userName" matInput
                    #userName placeholder="" style="color: #18181a;">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row no-gutters col-12 d-flex align-items-center justify-content-center pt-4">
        <button class="btn btn-primary btn-vernova button col-xl-2 col-md-6 col-sm-8 text-normal"
            onclick="location.href='https://nextgen.ge-registrar.com/b2bregistration/index.html#/protected/modifyaccount'"
            type="button">
            <span>
                Modify Your Account
            </span>
        </button>
    </div>
    <br>
</form>